// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import vClickOutside from 'v-click-outside';
import smoothscroll from 'smoothscroll-polyfill';
import Toasted from 'vue-toasted';
import apiService from 'src/utils/apiService';
import 'normalize.css';

// Declare uikit globally
import ButtonEl from 'Uikit/ButtonEl';
import SearchControl from 'Uikit/SearchControl';
import InputEl from 'Uikit/InputEl';
import TextareaEl from 'Uikit/TextareaEl';
import HeadTitle from 'Uikit/HeadTitle';
import SelectBox from 'Uikit/SelectBox';
import RedText from 'Uikit/RedText';
import RedLabel from 'Uikit/RedLabel';
import GrayText from 'Uikit/GrayText';
import GreenText from 'Uikit/GreenText';
import CheckboxEl from 'Uikit/CheckboxEl';
import RadioEl from 'Uikit/RadioEl';
import SwitcherEl from 'Uikit/SwitcherEl';
import TableEl from 'Uikit/TableEl';
import Tooltip from 'Uikit/Tooltip';
import RoundBtn from 'Uikit/RoundBtn';
import LoadMoreBtn from 'Uikit/LoadMoreBtn';
import AddFavoriteBtn from 'Uikit/AddFavoriteBtn';
import CurrencySelector from 'Uikit/CurrencySelector';
import StagesLegend from 'Uikit/StagesLegend';
import SpinnerEl from 'Uikit/SpinnerEl';
import IconBase from 'Uikit/IconBase';
import PercentTrend from 'Uikit/PercentTrend';
import ListEl from 'Uikit/ListEl';
import SquareBtn from 'Uikit/SquareBtn';
import CurrencyIcon from 'Uikit/CurrencyIcon';
import GraphEl from 'Uikit/GraphEl';
import InfoField from 'Uikit/InfoField';
import DotsSpinner from 'Uikit/DotsSpinner';

import './styles/common.scss';
import App from './App';
import router from './router/';
import store from './store/';

Vue.component('button-el', ButtonEl);
Vue.component('search-control', SearchControl);
Vue.component('input-el', InputEl);
Vue.component('textarea-el', TextareaEl);
Vue.component('head-title', HeadTitle);
Vue.component('select-box', SelectBox);
Vue.component('red-text', RedText);
Vue.component('red-label', RedLabel);
Vue.component('gray-text', GrayText);
Vue.component('green-text', GreenText);
Vue.component('checkbox-el', CheckboxEl);
Vue.component('radio-el', RadioEl);
Vue.component('switcher-el', SwitcherEl);
Vue.component('table-el', TableEl);
Vue.component('tooltip', Tooltip);
Vue.component('round-btn', RoundBtn);
Vue.component('load-more-btn', LoadMoreBtn);
Vue.component('add-favorite-btn', AddFavoriteBtn);
Vue.component('currency-selector', CurrencySelector);
Vue.component('stages-legend', StagesLegend);
Vue.component('spinner-el', SpinnerEl);
Vue.component('percent-trend', PercentTrend);
Vue.component('list-el', ListEl);
Vue.component('icon-base', IconBase);
Vue.component('square-btn', SquareBtn);
Vue.component('currency-icon', CurrencyIcon);
Vue.component('graph-el', GraphEl);
Vue.component('info-field', InfoField);
Vue.component('dots-spinner', DotsSpinner);
// /Declare uikit globally

Vue.config.productionTip = false;
Vue.use(vClickOutside);
Vue.use(Vuelidate);
Vue.use(Toasted);

Vue.prototype.$apiService = apiService;

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  template: '<App/>',
  components: { App },
});

smoothscroll.polyfill();



// WEBPACK FOOTER //
// ./src/main.js